import { React, Fragment } from "react";
import { CommonGrid2 } from "../common-components/StyledComponents";
import {Typography, Box, Collapse} from "@mui/material";
import { platformBlackLogo } from "../../utils/logo";
import { CustomizeSpan } from "../jobs/style";
import FullSizeChatBot from "../chat-bot/FullSizeChatBot";
import { CustomDiv } from "../chat-bot/style";
import GeminiIco from "../../assets/icons/GeminiIco";
import CandidateSuggestionIco from "../../assets/icons/CandidateSuggestionIco";
import JobSugesstionIco from "../../assets/icons/JobSugesstionIco";
import CommonButton from "../../component/Button";
import { HandleSkeletion } from "../../utils/constants";
import { GetWhiteLabelAvatar } from "../common-components/CoverSheetFunction";

function ChatView({ 
    details, 
    lg,
    isBottomVisible,
    setIsBottomVisible,
    showSuggestions,
    setShowSuggestions,
    chatBotData,
    customDivRef,
    customDivHeight,
    handleChatBotChange,
    handleButtonClickByLabel,
    handleSendMessage,
    skeletonLoader,
    setSkeletonLoader,
}) {
    const iconMap = {
        chat: <GeminiIco />,
        candidate: <CandidateSuggestionIco />,
        job: <JobSugesstionIco />,
    }
    console.log(details,"details");

    return (
        <CommonGrid2>
            <CommonGrid2
                display="flex"
                flexDirection={"row"}
                justifyContent={"space-between"}
                alignItems={"center"}
                width={"100%"}
                padding={"1rem"}
                customStyle={{ boxShadow: "0px 4px 14.8px 0px rgba(0, 0, 0, 0.1)"}}
            > 
                <CommonGrid2
                    display="flex"
                    flexDirection={"column"}
                >
                    {skeletonLoader ? 
                    (<HandleSkeletion 
                        width="100px" 
                        height="45px" 
                        margin={"0px 1rem 0px 0px"} 
                    />) : (
                    <Fragment>
                        <Typography 
                            variant={lg ? "h5" : "h5xs"}
                            fontWeight={"700"}
                            fontStyle={"Bold"}
                        >
                            {details?.job_info?.job_title || "Job Title"}
                        </Typography>
                        <Typography 
                            variant={ lg ? "body2" : "body2xs"}
                            fontWeight={"700"}
                            fontStyle={"Bold"}
                            color={"#7F56D9"}
                        >
                            {details?.job_info?.company_name || "Company"} - <CustomizeSpan color={"#5B738B"} fontWeight={"400"}>{details?.job_info?.req_id || "N/A"}</CustomizeSpan>
                        </Typography>
                    </Fragment>
                    )}
                </CommonGrid2>
                <CommonGrid2 
                    display={"flex"} 
                    flexDirection={"column"}
                    alignItems={"center"}
                    justifyContent={"center"}
                >
                    {skeletonLoader ? 
                    (<HandleSkeletion 
                        width="100px" 
                        height="45px" 
                        margin={"0px 1rem 0px 0px"} 
                    />) : (
                    <Fragment>
                        {/* <Typography fontSize={"10px"} color={"#5B738B"} textAlign={"center"}>Powered by TalAiro</Typography> */}
                        {details?.org_label || (details?.org_logo_url && typeof details?.org_logo_url === "string") ?
                            (
                                GetWhiteLabelAvatar(details.org_logo_url, details?.org_label, lg)
                            ) : (
                                platformBlackLogo({height: "40px"})
                            )
                        }
                    </Fragment>
                    )}
                </CommonGrid2>
            </CommonGrid2>
            <CommonGrid2
                sx={{
                    width: {
                        xs: "90%",
                        sm: "80%",   
                        md: "80%",  
                    },
                    height: {
                        xs: `calc(100vh - ${customDivHeight}px - 175px)`,
                        sm: `calc(100vh - ${customDivHeight}px - 200px)`,
                        md: `calc(100vh - ${customDivHeight}px - 200px)`,
                    }
                }}
                margin={"0 auto"}   
            >
                <CustomDiv ref={customDivRef} margin={lg ? "1rem 0" : "0.5rem 0"}>
                    {skeletonLoader ? 
                    (<HandleSkeletion 
                        width="100px" 
                        height="45px" 
                        margin={"0px 1rem 0px 0px"} 
                    />) : (
                    <Fragment>
                        <Typography
                            variant={lg ? "h2" : "h2xs"}
                            color="#8396A8"
                            fontWeight={700}
                            sx={{
                                background:
                                "linear-gradient(98deg, #5A35B2 1.87%, #FA4F96 14.6%)",
                                WebkitBackgroundClip: "text",
                                WebkitTextFillColor: "transparent",
                            }}
                        >
                            Hello, {details?.name || "User"}                    
                        </Typography>
                    </Fragment>
                    )}
                    <CommonGrid2
                        display={"flex"}
                        flexDirection={"row"}
                        alignItems={"center"}
                        justifyContent={"space-between"}
                        marginTop={lg ? "0.5rem" : "0rem"}
                    >
                        {skeletonLoader ? 
                        (<HandleSkeletion 
                            width="100px" 
                            height="45px" 
                            margin={"0px 1rem 0px 0px"} 
                        />) : (
                            <Fragment>
                                <Typography variant={lg ? "h2" : "h2xs"} color="#8396A8" fontWeight={700}>How can I help you ?</Typography>
                            </Fragment>
                        )}
                        {skeletonLoader ? 
                        (<HandleSkeletion 
                            width="100px" 
                            height="45px" 
                            margin={"0px 1rem 0px 0px"} 
                        />) : (
                        <Fragment>
                            <Typography
                                variant={lg ? "subtitle2" : "subtitle2xs"}
                                fontWeight={600}
                                color="#5A35B2"
                                onClick={() => setShowSuggestions(!showSuggestions)}
                                sx={{
                                    display: {
                                        xs: "flex",
                                        sm: "flex",
                                        md: "flex",
                                    },
                                    padding: "4px",
                                    cursor: "pointer",
                                }}
                            >
                                {showSuggestions ? "Hide Suggestions" : "Show Suggestions"}
                            </Typography>
                        </Fragment>
                        )}
                    </CommonGrid2>
                    <CommonGrid2
                        display={"flex"}
                        gap={"10px"}
                        flexDirection={"row"}
                        marginTop={showSuggestions ? lg ? "1rem" : "0.5rem" : "0rem"}
                        flexWrap={"wrap"}
                    >
                        <Collapse
                            in={showSuggestions}
                            timeout="auto"
                            unmountOnExit
                            sx={{
                                width: {
                                    xs: "100%",
                                    sm: "100%",
                                    md: "100%",
                                },
                                "& .MuiCollapse-wrapperInner": {
                                    display: "flex",
                                    flexDirection: {
                                        xs: "column",
                                        sm: "row",
                                        md: "row",
                                    },
                                    gap: "10px",
                                }
                            }}
                           
                        >
                        {details?.suggestions?.map((item) => (
                        <Box
                            key={item.question}
                            sx={{
                                width: {
                                    xs: "100%",
                                    sm: "max-content",   
                                    md: "250px",  
                                }
                            }}
                        >
                            {skeletonLoader ? 
                            (<HandleSkeletion 
                                width="100px" 
                                height="45px" 
                                margin={"0px 1rem 0px 0px"} 
                            />) : (
                            <Fragment>
                                <CommonButton
                                    startIcon={iconMap[item.icon_type]}
                                    value={item.question}
                                    variant="outlined"
                                    border={" #EAECF0"}
                                    color="#101828"
                                    borderRadius="7px"
                                    padding={"8px 10px"}
                                    gap={"0px"}
                                    width={"100%"}
                                    customStyle={{
                                        justifyContent: "start",
                                    }}
                                    disabled={chatBotData.pageLoader || chatBotData.loader}
                                    onClick={() => handleButtonClickByLabel(item)}
                                />
                            </Fragment>
                            )}
                        </Box>
                        ))}
                        </Collapse>
                    </CommonGrid2>
                </CustomDiv>
            <FullSizeChatBot
                    // disabled={jobData.data?.length === 0}
                    chatBotData={chatBotData}
                    handleChatBotChange={handleChatBotChange}
                    setIsBottomVisible={setIsBottomVisible}
                    isBottomVisible={isBottomVisible}
                    handleSendMessage={handleSendMessage}
                    customStyle={{
                    width: "calc(100% + 16px)",
                    padding: "0px 10px 0px 5px",
                    "&::-webkit-scrollbar": {
                        width: "6px",
                    },
                    }}
                />
            </CommonGrid2>
        </CommonGrid2>
    )
}

export default ChatView;